<template>
    <div class="video-player">
        <div class="video-player__title">{{ channelName }}</div>
        <div class="video-box">
            <video ref="videoPlayer" class="video-js"></video>
        </div>
    </div>
</template>

<script>
import videojs from 'video.js'
import 'videojs-flash'
import 'videojs-contrib-hls'

export default {
    name: 'VideoPlayer',
    props: {
        channelName: {
            type: String,
            required: true
        },
        url: {
            type: String,
            required: true
        },
        isLive: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            player: null
        }
    },
    mounted () {
        let options = {
            autoplay: true,
            controls: true,
            techOrder: ['html5', 'flash']
        }

        this.player = videojs(this.$refs.videoPlayer, options, () => this.playVideo())
        this.player.on('error', (error) => {
            console.error(error)
        })
    },
    beforeDestroy () {
        if (this.player) {
            this.player.dispose()
        }
    },
    methods: {
        playVideo () {
            const video = {
                type: 'application/x-mpegurl',
                isLive: true,
                src: this.url
            }

            setTimeout(() => {
                this.player.reset()
                this.player.src(video)
                this.player.play()
            }, 500)
        }
    }
}
</script>

<style scoped lang="scss">
.video-player {
    padding: 10px 5px;
    width: 100%;

    &__title {
        text-align: center;
        background: $secondary;
        color: white;
        padding: 13px 0;
        font-weight: bold;
    }

    .video-box {
        ::deep .video-js {
            width: 100% !important;
            height: 350px !important;
        }
    }
}
</style>
